import React from 'react';
import {ContainerInput} from "./ContainerInput";
import PropTypes from 'prop-types';

export const ContainerGroupForm = ({children, width}) => {
    return (
        <div className={`form-group ${width}`} >
            <ContainerInput>
                {children}
            </ContainerInput>
        </div>
    );
};


ContainerGroupForm.prototype = {
    width : PropTypes.string
}

ContainerGroupForm.defaultProps = {
    width :"lg:w-6/12"
}

